
import { DocumentContentEditor } from "./DocumentContentEditor";

interface OperationsManualViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function OperationsManualView({ content, documentId, onUpdate }: OperationsManualViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Operational Overview</h2>
        <DocumentContentEditor
          section="Operational Overview"
          content={content.operationalOverview}
          documentId={documentId}
          field="operationalOverview"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Standard Operating Procedures</h2>
        <DocumentContentEditor
          section="Standard Operating Procedures"
          content={content.standardOperatingProcedures}
          documentId={documentId}
          field="standardOperatingProcedures"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Departmental Procedures</h2>
        <DocumentContentEditor
          section="Departmental Procedures"
          content={content.departmentalProcedures}
          documentId={documentId}
          field="departmentalProcedures"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Quality Standards</h2>
        <DocumentContentEditor
          section="Quality Standards"
          content={content.qualityStandards}
          documentId={documentId}
          field="qualityStandards"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Emergency Procedures</h2>
        <DocumentContentEditor
          section="Emergency Procedures"
          content={content.emergencyProcedures}
          documentId={documentId}
          field="emergencyProcedures"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Training Guidelines</h2>
        <DocumentContentEditor
          section="Training Guidelines"
          content={content.trainingGuidelines}
          documentId={documentId}
          field="trainingGuidelines"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
